import { httpClient, handleErrorResp, getToken, removeNulls } from "../UtilService";
import { IStandardAPIResponse, IAuditLog, IAuthLog, IAuditLogFilters, IAuthLogFilters } from "../../vm";
import { API_URL } from "../../components/common/Constants";

export async function getAuditLogs(
  filters: IAuditLogFilters
): Promise<IStandardAPIResponse<{ data: IAuditLog[]; total: number }>> {
  try {
    const sanitizedFilters = removeNulls({ ...filters });
    return await httpClient("audit-logs", "GET", sanitizedFilters);
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function getAuthLogs(
  filters: IAuthLogFilters
): Promise<IStandardAPIResponse<{ data: IAuthLog[]; total: number }>> {
  try {
    const sanitizedFilters = removeNulls({ ...filters });
    return await httpClient("auth-logs", "GET", sanitizedFilters);
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function exportAuditLogsExcel(filters: IAuditLogFilters): Promise<void> {
  const sanitizedFilters = removeNulls({ ...filters }) as IAuditLogFilters;
  const params = new URLSearchParams();
  if (sanitizedFilters.startDate) params.set("startDate", sanitizedFilters.startDate);
  if (sanitizedFilters.endDate) params.set("endDate", sanitizedFilters.endDate);
  if (sanitizedFilters.userId) params.set("userId", sanitizedFilters.userId);
  if (sanitizedFilters.action) params.set("action", sanitizedFilters.action);
  if (sanitizedFilters.resource) params.set("resource", sanitizedFilters.resource);
  if (sanitizedFilters.search) params.set("search", sanitizedFilters.search);

  const response = await fetch(`${API_URL}audit-logs/export?${params.toString()}`, {
    method: "GET",
    credentials: "include",
    headers: { at: getToken() },
  });

  if (!response.ok) return;

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `MOR_Audit_Logs_${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function exportAuthLogsExcel(filters: IAuthLogFilters): Promise<void> {
  const sanitizedFilters = removeNulls({ ...filters }) as IAuthLogFilters;
  const params = new URLSearchParams();
  if (sanitizedFilters.startDate) params.set("startDate", sanitizedFilters.startDate);
  if (sanitizedFilters.endDate) params.set("endDate", sanitizedFilters.endDate);
  if (sanitizedFilters.userId) params.set("userId", sanitizedFilters.userId);
  if (sanitizedFilters.event) params.set("event", sanitizedFilters.event);
  if (sanitizedFilters.status) params.set("status", sanitizedFilters.status);
  if (sanitizedFilters.search) params.set("search", sanitizedFilters.search);

  const response = await fetch(`${API_URL}auth-logs/export?${params.toString()}`, {
    method: "GET",
    credentials: "include",
    headers: { at: getToken() },
  });

  if (!response.ok) return;

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `MOR_Authentication_Logs_${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
